export default __webpack_public_path__ + "static/media/84.954829b5.png";